import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import { Col, Container, Row } from "react-bootstrap";
import { useMediaQuery } from "../../helpers/useMediaQuery";
import { useNavigate } from "react-router-dom";
import { getRecordedLiveLessonVideoForMobile } from "../../services/lesson.service";
import Loader from "../common/loader/Loader";
import Error from "../common/error/Error";
import { t } from "i18next";
import NextLessons from "../recordedLiveLesson/nextLessons/NextLessons";
import VideoPlayer from "../recordedLiveLesson/videoPlayer/VideoPlayer";
const RecordedLIveLesson = () => {
  const isTablet = useMediaQuery("(max-width: 992px)");
  let params = new URL(document.location).searchParams;
  let sessionId = params.get("sessionId");
  let token = params.get("token");
  const [data, setData] = useState();
  const [videos, setVideos] = useState();
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const navigate = useNavigate();
  const [videoUrl, setVideoUrl] = useState();

  const getVideo = async () => {
    setIsVideoLoading(true);
    const resoponse = await getRecordedLiveLessonVideoForMobile(
      sessionId,
      token
    );
    if (resoponse?.status === 200) {
      if (resoponse?.data?.data) {
        setData(resoponse?.data?.data);
        setVideos(resoponse?.data?.data?.recordings);
        setVideoUrl(resoponse?.data?.data?.recordings[0]);
      }
      setIsVideoLoading(false);
    } else {
      setIsVideoLoading(false);
      navigate("/error", { replace: true });
    }
  };

  useEffect(() => {
    getVideo();
  }, []);

  return (
    <Styles>
      <section id="recordedLessonPage">
        <Container>
          {isVideoLoading ? (
            <Loader height={"80vh"} paddingTop={"15rem"} />
          ) : videos?.length > 0 ? (
            <Row className="row-container">
              <h3 className="title">{data?.name}</h3>
              {/* <p className="description">{data?.description}</p> */}
              <div dangerouslySetInnerHTML={{ __html: data?.description }} />
              {!isTablet && videos && (
                <Col lg={3}>
                  <NextLessons
                    isLoading={isVideoLoading}
                    lessons={videos}
                    videoUrl={videoUrl}
                    setVideoUrl={setVideoUrl}
                  />
                </Col>
              )}
              {videoUrl && (
                <Col lg={videos ? 9 : 12}>
                  <VideoPlayer
                    video={videoUrl}
                    // thumbnail={Logo}
                    // isLoading={isLoading}
                  />
                </Col>
              )}
              {isTablet && (
                <Col xs={12}>
                  <NextLessons
                    // isLoading={isLoading}
                    lessons={videos}
                    videoUrl={videoUrl}
                    setVideoUrl={setVideoUrl}
                  />
                </Col>
              )}
            </Row>
          ) : (
            <div className="row-container">
              <Error paddingTop={"18%"} message={t("prepare_records")} />
            </div>
          )}
        </Container>
      </section>
    </Styles>
  );
};

export default RecordedLIveLesson;
